import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import InstagramFillIcon from 'components/common/icons/fill/instagram-fill';
import FacebookMessengerFillIcon from 'components/common/icons/fill/facebook-messenger-fill';
import TwitterFillIcon from 'components/common/icons/fill/twitter-fill';

import Button, { ButtonTypes } from 'components/common/button';
import { MenuContainer, MenuItem } from 'components/lib/menu_deprecated';

function AddChannelMenu({
  authorizeTwitter,
  className,
  isInstagramMessagingEnabled,
  hasTwitterEndpoint,
  loginToFb,
  multipleTwitterChannels,
  title,
}) {
  function renderDropdownButton() {
    return <Button buttonType={ButtonTypes.SECONDARY}>{title}</Button>;
  }

  function instagramMessagingMenu() {
    if (!isInstagramMessagingEnabled) {
      return null;
    }
    return (
      <MenuItem className="channels-addChannelMenu-item channels-addChannelMenu-instagramDirectItem">
        <InstagramFillIcon className="channels-addChannelMenu-item-icon" />
        Instagram Direct
      </MenuItem>
    );
  }

  function facebookMessengerMenu() {
    return (
      <MenuItem onSelect={loginToFb} className="channels-addChannelMenu-item channels-addChannelMenu-messengerItem">
        <FacebookMessengerFillIcon className="channels-addChannelMenu-item-icon" />
        Facebook Messenger
      </MenuItem>
    );
  }

  function twitterAuthorizationMenu() {
    if (!multipleTwitterChannels && hasTwitterEndpoint) {
      return null;
    }
    return (
      <MenuItem
        onSelect={authorizeTwitter}
        className="channels-addChannelMenu-item channels-addChannelMenu-twitterItem"
      >
        <TwitterFillIcon className="channels-addChannelMenu-item-icon" />
        Twitter
      </MenuItem>
    );
  }

  return (
    <MenuContainer className={classnames('channels-addChannelMenu', className)} button={renderDropdownButton()}>
      {instagramMessagingMenu()}
      {facebookMessengerMenu()}
      {twitterAuthorizationMenu()}
    </MenuContainer>
  );
}

AddChannelMenu.propTypes = {
  authorizeTwitter: PropTypes.func.isRequired,
  className: PropTypes.string,
  isInstagramMessagingEnabled: PropTypes.bool.isRequired,
  hasTwitterEndpoint: PropTypes.bool.isRequired,
  loginToFb: PropTypes.func.isRequired,
  multipleTwitterChannels: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default AddChannelMenu;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/add_channel_menu.jsx